// Moneda de VISTA de la tienda (pedido del dueño, 2026-10-14): el cliente
// puede ver todo -- precios, carrito, saldo, historial, movimientos y avisos --
// en USD al tipo de cambio actual de Binance (USDT/MXN). Todo se sigue
// cobrando en pesos; solo cambia cómo se ve. Store() actualiza VIEW en cada
// render, así que todo lo que se dibuja dentro de la tienda lo lee al día.
// Los montos viejos (historial) se convierten al tipo de cambio de HOY.
export const VIEW = { cur: "MXN", rate: null };

const CUR_KEY = "mq_view_currency";
const RATE_KEY = "mq_usdt_rate";

export const fmt2 = (n) => Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const moneyMxn = (n) => `$${fmt2(n)}`;
export const money = (n) => (VIEW.cur === "USDT" && VIEW.rate ? `${fmt2(Number(n || 0) / VIEW.rate)} USD` : moneyMxn(n));

// Textos que arma el servidor ("compró por $40.00 MXN", "Tenías $300 → ...")
// traen los montos en pesos dentro del texto: en USD se reescriben.
export const moneyText = (txt) => {
  if (!txt || VIEW.cur !== "USDT" || !VIEW.rate) return txt;
  return String(txt).replace(/\$\s?(\d[\d,]*(?:\.\d+)?)(\s*MXN)?/g, (_, num) => money(Number(num.replace(/,/g, ""))));
};

export const storedCurrency = () => { try { return localStorage.getItem(CUR_KEY) || "MXN"; } catch { return "MXN"; } };
export const saveCurrency = (c) => { try { localStorage.setItem(CUR_KEY, c); } catch { /* sin storage */ } };
// Último tipo de cambio conocido: así al volver a la tienda los montos salen
// en USD desde el primer momento, sin parpadear en pesos mientras carga.
export const storedRate = () => { try { const r = Number(localStorage.getItem(RATE_KEY)); return r > 0 ? r : null; } catch { return null; } };
export const saveRate = (r) => { try { localStorage.setItem(RATE_KEY, String(r)); } catch { /* sin storage */ } };
